import { ContextMenuStore } from './types';
import { isWordsContextMenuConfig } from './utils';

export const wordsContextMenuConfigSelector = (state?: ContextMenuStore) =>
  isWordsContextMenuConfig(state?.config) ? state?.config : undefined;

export const lastSuccessfulActionSelector = (state: ContextMenuStore) =>
  state.lastSuccessfulAction;
